// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {buildHighOnRentalDaysPayload} from '../../../product/shared/services/build-high-rental-days-payload';
import {getFileName} from '../../../shared/services/get-file-name';
import {getHighOnRentalDays} from '../../shared/repositories/index';
import {openFile} from '../../../shared/services/open-file';

export const highRentalDaysExportToExcel = (dealerAccounts, language) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());
        const highRentalDaysPayload = buildHighOnRentalDaysPayload(dealerAccounts, 'EXCEL', language);

        try {

            const response = await getHighOnRentalDays(highRentalDaysPayload);

            const fileName = getFileName(response);

            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/high-rental-days-export-to-excel.js